import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import asyncComponent from '../../util/AsyncFunc';

import AuditList from './AuditList/index'


//auth
import {
    userIsAuthenticatedRedir, userIsNotAuthenticatedRedir,
    userIsAuthenticated, userIsNotAuthenticated, userIsSuperAdminRedir,
    userIsBoardAdminRedir, userIsCommitteeAdminRedir, userIsCheckerAdminRedir
} from '../auth'

const AuditListProtected_ba = userIsBoardAdminRedir(AuditList)

const audit = ({ match }) => (
    <div className="app-wrapper">
        <Switch>
            <Redirect exact from={`${match.url}/`} to={`${match.url}/audit-list`} />       
            <Route path={`${match.url}/audit-list/:audittype`} component={AuditListProtected_ba} />
        </Switch>
    </div>
);

export default audit;


// WEBPACK FOOTER //
// ./app/auditdetails/index.js